module.exports = __webpack_public_path__ + "static/media/notification-icon-active.5483b774.svg";